import { render } from "./NowLoading.vue?vue&type=template&id=1ad35b20&scoped=true"
import script from "./NowLoading.vue?vue&type=script&lang=js"
export * from "./NowLoading.vue?vue&type=script&lang=js"

import "./NowLoading.vue?vue&type=style&index=0&id=1ad35b20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad35b20"]])

export default __exports__